import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { GroupModel } from '@app/core/models/groups/group.model';
import { GroupService } from '@app/core/services/group.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MultiSelectModel } from '@app/shared/models/multi-select.model';
import { TableRowAction } from '@app/shared/models/table-action-type.model';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as _ from 'lodash';


@Component({
  selector: 'app-group-transfer-users',
  templateUrl: './group-transfer-users.component.html',
  styleUrls: ['./group-transfer-users.component.scss']
})
export class GroupTransferUsersComponent implements OnInit, OnDestroy {

  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  groupDropDownSettings: IDropdownSettings;
  tableActions: TableRowAction[] = [];
  groups: GroupModel[] = [];
  targetGroups: GroupModel[];
  sourceGroupId: number;
  sourceGroupName: string;

  constructor(
    private groupService: GroupService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<GroupTransferUsersComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
    this.sourceGroupId = data.Id;
    this.sourceGroupName = data.Name;
  }

  ngOnInit() {

    this.groupDropDownSettings = new MultiSelectModel().getSettings('Id', 'Name', true, true, true);

    this.groupService.getGroupsByType()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((groups: GroupModel[]) => {
        this.groups = groups.filter(g => g.Id != this.sourceGroupId);
      });
  }

  onSubmit = () => {
    const targetGroup = _.head(this.targetGroups);
    const confirmationMessage = `Êtes-vous sûr de vouloir transférer tous les utilisateurs du groupe <strong>${this.sourceGroupName}</strong> vers <strong>${targetGroup.Name}</strong> ?`;
    const modalConfig = new ModalHelper().getConfirmationConfig(confirmationMessage);
    const dialog = this.dialog.open(ModalComponent, modalConfig);

    dialog.afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(result => {
        if (result) {
          this.groupService.transferUsers(this.sourceGroupId, targetGroup.Id)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => this.close(true),
              () => this.close(false));
        }
      });
  }

  close(isSuccess: boolean) {
    this.dialogRef.close(isSuccess);
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }
}
